import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/intake/app/global-error.tsx");
